// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-shortcut-list__container {
    background: var(--white-color);
    /* box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32); */
    /* border-radius: 12px; */
    /* margin-bottom: calc(var(--space-and-half) + var(--space-eighth)); */
    /* padding-top: var(--space-and-half);
  padding-bottom: var(--space-and-half); */
}

.homepage-shortcut-list__list .baloa-names {
    color: var(--primary-very-dark-color);
    margin-left: var(--space-half);
}

.homepage-shortcut_item {
    cursor: pointer;
}

.homepage-shortcut-list__section {
    display: flex;
    flex-direction: row;
    align-items: center;
    /*   margin-left: var(--space-and-half);
  margin-bottom: var(--space-and-half); */
    padding: 10px;
    margin-top: 12px;
}

.homepage-shortcut-list__section:first-child {
    margin-top: 0;
}

.homepage-shortcut-list__section span {
    font-size: var(--space-x2);
}

.homepage-shortcut-list__section .icon-player,
.homepage-shortcut-list__section .icon-coach {
    color: var(--white-color);
    background: #EB3B3B;
    border-radius: 50%;
    padding: 3px;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.homepage-shortcut-list__section .hubicon-live_tv1 {
  color: var(--white-color);
  background: #0D6EFD;
  border-radius: 50%;
  padding: 3px;
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.home-shortcuts__baloa-landing {
    background-color: #EAF7F0;
    padding: 10px 8px;
    gap: 8px;
    white-space: nowrap;
    margin-left: 15px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .homepage-shortcut-list__section .icon-player,
    .homepage-shortcut-list__section .icon-coach,
    .homepage-shortcut-list__section .hubicon-live_tv1 {
        padding: 2px;
        font-size: 20px;
    }

    .homepage-shortcut-list__section {
        margin-top: 0;
        padding: 10px 15px;
    }

    .homepage-shortcut-list__list .baloa-pro-subscription-widget__container {
        margin: 10px 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/home/components/home-shortcuts/HomeShortCutsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,mEAAmE;IACnE,yBAAyB;IACzB,sEAAsE;IACtE;0CACsC;AAC1C;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;yCACqC;IACrC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;;IAEjE;;;QAGI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".homepage-shortcut-list__container {\n    background: var(--white-color);\n    /* box-shadow: 0px 3.35742px 3.35742px rgba(170, 193, 182, 0.32); */\n    /* border-radius: 12px; */\n    /* margin-bottom: calc(var(--space-and-half) + var(--space-eighth)); */\n    /* padding-top: var(--space-and-half);\n  padding-bottom: var(--space-and-half); */\n}\n\n.homepage-shortcut-list__list .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-left: var(--space-half);\n}\n\n.homepage-shortcut_item {\n    cursor: pointer;\n}\n\n.homepage-shortcut-list__section {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    /*   margin-left: var(--space-and-half);\n  margin-bottom: var(--space-and-half); */\n    padding: 10px;\n    margin-top: 12px;\n}\n\n.homepage-shortcut-list__section:first-child {\n    margin-top: 0;\n}\n\n.homepage-shortcut-list__section span {\n    font-size: var(--space-x2);\n}\n\n.homepage-shortcut-list__section .icon-player,\n.homepage-shortcut-list__section .icon-coach {\n    color: var(--white-color);\n    background: #EB3B3B;\n    border-radius: 50%;\n    padding: 3px;\n    font-size: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.homepage-shortcut-list__section .hubicon-live_tv1 {\n  color: var(--white-color);\n  background: #0D6EFD;\n  border-radius: 50%;\n  padding: 3px;\n  font-size: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.home-shortcuts__baloa-landing {\n    background-color: #EAF7F0;\n    padding: 10px 8px;\n    gap: 8px;\n    white-space: nowrap;\n    margin-left: 15px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .homepage-shortcut-list__section .icon-player,\n    .homepage-shortcut-list__section .icon-coach,\n    .homepage-shortcut-list__section .hubicon-live_tv1 {\n        padding: 2px;\n        font-size: 20px;\n    }\n\n    .homepage-shortcut-list__section {\n        margin-top: 0;\n        padding: 10px 15px;\n    }\n\n    .homepage-shortcut-list__list .baloa-pro-subscription-widget__container {\n        margin: 10px 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
